/**
 * Recursively calls `Object.freeze` directly on input.
 * Useful for guarding against any accidental mutations.
 * @param obj
 */
export const deepFreeze = <T extends {[key: string]: any}>(obj: T): T => {
  // Freeze properties
  Object.getOwnPropertyNames(obj).forEach((name) => {
    const prop = obj[name]

    // Recurse on nested objects
    if (typeof prop === 'object' && prop !== null)
      deepFreeze(prop)
  })

  // Freeze self
  return Object.freeze(obj)
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/utils/freeze.ts